import React, { useState, useEffect } from 'react';
import { getData, saveData, db } from '../firebase';
import { doc, deleteDoc } from 'firebase/firestore';

const BRAND = '#0f6e56';
const CATS = ['Food & Supplies','Rent','Utilities','Transport','Marketing','Equipment','Salaries','Other'];

export default function Expenses({ user }) {
  const [expenses, setExpenses] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filterCat, setFilterCat] = useState('All');
  const [form, setForm] = useState({ description:'', amount:'', category:'Other', date:new Date().toISOString().slice(0,10) });

  const load = async () => {
    setLoading(true);
    const data = await getData(user.uid, 'expenses');
    setExpenses(data);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const addExpense = async (e) => {
    e.preventDefault();
    if (!form.description || !form.amount) return;
    await saveData(user.uid, 'expenses', { ...form, amount:parseFloat(form.amount)||0 });
    setShowForm(false);
    setForm({ description:'', amount:'', category:'Other', date:new Date().toISOString().slice(0,10) });
    load();
  };

  const delExp = async (id) => {
    if (!window.confirm('Delete this expense?')) return;
    await deleteDoc(doc(db, 'users', user.uid, 'expenses', id));
    load();
  };

  const fmt = n => '$' + Number(n||0).toLocaleString('en-US', { minimumFractionDigits:2, maximumFractionDigits:2 });
  const filtered = expenses.filter(e => filterCat === 'All' || e.category === filterCat);
  const total = filtered.reduce((s,e) => s+e.amount, 0);
  const expByCategory = {};
  expenses.forEach(e => { expByCategory[e.category] = (expByCategory[e.category]||0) + e.amount; });

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <h2 style={{ fontSize:22, fontWeight:700 }}>Expenses</h2>
        <button onClick={() => setShowForm(true)} style={btnStyle}>+ Add Expense</button>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:20 }}>
        <div style={{ background:'#fcebeb', borderRadius:12, padding:20 }}>
          <div style={{ fontSize:12, color:'#a32d2d', marginBottom:4, textTransform:'uppercase' }}>Total expenses</div>
          <div style={{ fontSize:26, fontWeight:700, color:'#a32d2d' }}>{fmt(total)}</div>
        </div>
        <div style={{ background:'#fff', borderRadius:12, padding:20, border:'1px solid #e8e8e8' }}>
          <div style={{ fontSize:12, color:'#888', marginBottom:4, textTransform:'uppercase' }}>Total entries</div>
          <div style={{ fontSize:26, fontWeight:700, color:'#555' }}>{filtered.length}</div>
        </div>
      </div>

      <div style={{ background:'#fff', borderRadius:12, padding:16, border:'1px solid #e8e8e8', marginBottom:20 }}>
        <div style={{ fontSize:14, fontWeight:600, marginBottom:12 }}>By category</div>
        <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
          {['All', ...Object.keys(expByCategory)].map(c => (
            <button key={c} onClick={() => setFilterCat(c)} style={{
              padding:'5px 12px', borderRadius:20, fontSize:12, cursor:'pointer',
              border:`1px solid ${filterCat===c ? '#a32d2d' : '#ddd'}`,
              background: filterCat===c ? '#a32d2d' : '#fff',
              color: filterCat===c ? '#fff' : '#555', fontWeight: filterCat===c ? 600 : 400
            }}>{c}{c !== 'All' ? ` (${fmt(expByCategory[c])})` : ''}</button>
          ))}
        </div>
      </div>

      {loading ? <div style={{ textAlign:'center', padding:40, color:'#aaa' }}>Loading...</div> : (
        filtered.length === 0
          ? <div style={{ textAlign:'center', padding:60, color:'#aaa', background:'#fff', borderRadius:14, border:'1px solid #e8e8e8' }}>
              <div style={{ fontSize:40, marginBottom:12 }}>🧾</div>
              <div style={{ fontSize:16, fontWeight:500 }}>No expenses yet</div>
            </div>
          : <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
              {filtered.map((exp, i) => (
                <div key={exp.id} style={{ background:'#fff', borderRadius:12, padding:'14px 20px', border:'1px solid #e8e8e8', display:'flex', alignItems:'center', gap:16 }}>
                  <div style={{ width:40, height:40, borderRadius:10, background:'#fcebeb', display:'flex', alignItems:'center', justifyContent:'center', fontSize:18 }}>🧾</div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:15, fontWeight:600 }}>{exp.description}</div>
                    <div style={{ fontSize:12, color:'#888', marginTop:2 }}>{exp.category} · {exp.date}</div>
                  </div>
                  <div style={{ fontSize:18, fontWeight:700, color:'#a32d2d' }}>{fmt(exp.amount)}</div>
                  <button onClick={() => delExp(exp.id)} style={{ background:'none', border:'none', cursor:'pointer', color:'#e24b4a', fontSize:18 }}>🗑</button>
                </div>
              ))}
            </div>
      )}

      {showForm && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100, padding:20 }}>
          <div style={{ background:'#fff', borderRadius:16, padding:32, width:'100%', maxWidth:440 }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
              <div style={{ fontSize:18, fontWeight:700 }}>Add Expense</div>
              <button onClick={() => setShowForm(false)} style={{ background:'none', border:'none', fontSize:22, cursor:'pointer', color:'#888' }}>×</button>
            </div>
            <form onSubmit={addExpense}>
              <FField label="Description *" value={form.description} onChange={v => setForm(f=>({...f,description:v}))} placeholder="e.g. Office supplies" />
              <FField label="Amount *" type="number" value={form.amount} onChange={v => setForm(f=>({...f,amount:v}))} placeholder="0.00" />
              <FField label="Date" type="date" value={form.date} onChange={v => setForm(f=>({...f,date:v}))} />
              <div style={{ marginBottom:16 }}>
                <label style={{ display:'block', fontSize:13, fontWeight:500, color:'#555', marginBottom:8 }}>Category</label>
                <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
                  {CATS.map(c => (
                    <button key={c} type="button" onClick={() => setForm(f=>({...f,category:c}))} style={{
                      padding:'5px 12px', borderRadius:8, fontSize:12, cursor:'pointer',
                      border:`1px solid ${form.category===c ? '#a32d2d' : '#ddd'}`,
                      background: form.category===c ? '#a32d2d' : '#fff',
                      color: form.category===c ? '#fff' : '#555'
                    }}>{c}</button>
                  ))}
                </div>
              </div>
              <div style={{ display:'flex', gap:10 }}>
                <button type="button" onClick={() => setShowForm(false)} style={{ flex:1, padding:12, borderRadius:10, border:'1px solid #ddd', background:'#fff', cursor:'pointer' }}>Cancel</button>
                <button type="submit" style={{ flex:2, padding:12, background:'#a32d2d', color:'#fff', border:'none', borderRadius:10, fontWeight:700, cursor:'pointer' }}>Save Expense</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

function FField({ label, type='text', value, onChange, placeholder }) {
  return (
    <div style={{ marginBottom:14 }}>
      <label style={{ display:'block', fontSize:13, fontWeight:500, color:'#555', marginBottom:6 }}>{label}</label>
      <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder}
        style={{ width:'100%', padding:'10px 14px', border:'1px solid #ddd', borderRadius:10, fontSize:14, color:'#222', outline:'none' }} />
    </div>
  );
}

const btnStyle = { padding:'10px 20px', background:'#a32d2d', color:'#fff', border:'none', borderRadius:10, fontSize:14, fontWeight:600, cursor:'pointer' };
